const HALF_YEAR_IN_MS = 1000 * 60 * 60 * 24 * 183;

export function setUserLocaleCookie(I18n) {
  if (window.Cookie && !window.Cookie.get('user_locale')) {
    window.Cookie.set('user_locale', I18n.locale, {
      maxAge: HALF_YEAR_IN_MS,
    });
  }
}
